import { Loader } from "@devhop/ui";
import { useNavigate } from "@tanstack/react-router";
import { useEffect, useRef } from "react";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { useCreateFormMutation } from "../api/queries";

export function FormNewPage() {
  const nav = useNavigate({ from: "/app/forms/new" });
  const create = useCreateFormMutation();
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    void create
      .mutateAsync({
        title: "ຟອມໃໝ່",
        description: null,
        settings: null,
        fields: [],
      })
      .then((data) =>
        nav({
          to: "/app/forms/$id/edit",
          params: { id: data.form.id },
          replace: true,
        }),
      );
  }, [create, nav]);

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຟອມ", to: "/app/forms/dashboard" },
            { label: "ຟອມ", to: "/app/forms" },
            { label: "ສ້າງ" },
          ]}
        />
      </Header>
      <Main>
        <div className="flex flex-col items-center justify-center gap-3 py-20 text-muted-foreground">
          <Loader />
          <span className="text-sm">ກຳລັງສ້າງຟອມ...</span>
        </div>
      </Main>
    </>
  );
}
